import {
  ADMIN_ONBOARD_SET_CURRENT_USER,
  ADMIN_ONBOARD_SET_CURRENT_USER_DECODED_TOKEN,
  ADMIN_ONBOARD_UPDATE_SUBSCRIPTION_TYPE,
  ADMIN_ONBOARD_SET_CURBSIDE_LOCATION,
  ADMIN_ONBOARD_SET_CURBSIDE_LOCATION_ARR,
  ADMIN_ONBOARD_SET_FASTFOOD_CURBSIDE_LOCATION_ARR,
  ADMIN_ONBOARD_SET_MULTISERVICE_CURBSIDE_LOCATION_ARR,
  ADMIN_ONBOARD_SET_PLACE_ID,
  ADMIN_ONBOARD_SET_PLACE_ID_MARKER,
  ADMIN_ONBOARD_GET_MARKER_POSITION,
  ADMIN_ONBOARD_GET_OPEN_RESTAURANT_STATUS,
  ADMIN_ONBOARD_SET_RESTAURANT_DETAILS,
  ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS,
  ADMIN_ONBOARD_GET_VENDOR_MENU_CATEGORY,
  ADMIN_ONBOARD_GET_VENDOR_MENU_CATEGORY_ITEMS,
  ADMIN_ONBOARD_SET_PRODUCT_CLASSIFCATION,
  ADMIN_ONBOARD_SET_ACTIVE_ITEM_ID_MENU_SETUP,
  ADMIN_ONBOARD_GET_VENDOR_ADDED_TEMPLATES,
  ADMIN_ONBOARD_SET_ACTIVE_CATEGORY_DATA_MENU_SETUP,
  ADMIN_ONBOARD_GET_VENDOR_ALL_MENU_ITEMS,
  ADMIN_ONBOARD_GET_LOCAL_CATALOG_DATA,
  ADMIN_ONBOARD_ACTIVE_CATALOG_NAME,
  ADMIN_ONBOARD_ACTIVE_CATALOG_ID,
  ADMIN_ONBOARD_SELECTED_ITEMS_ID,
  ADMIN_ONBOARD_SELECTED_CATALOG_ITEMS,
  ADMIN_ONBOARD_CATALOG_SELECTED_CATEGORIES_ITEMS,
  ADMIN_ONBOARD_GET_LOCAL_ITEMS_DATA,
  LOG_OUT,
} from "../../types";
import isEmpty from "../../../store/validation/is-Empty";

const initialState = {
  place_id: {},
  placeIdMarker: {},
  markerPosition: [],
  restaurant_Open_Status: {},
  restaurantDetails: {},
  onboard_subscription_details: {},
  menuCategory: [],
  activeCategoryData: [],
  menuCategoryItems: [],
  activeItemId: "",
  vendor_templates: [],
  all_menu_items: [],
  all_local_catalog: [],
  all_local_catalog_items: [],
  activeCatalogName: "",
  activeCatalogId: "",
  selectedCatalogId: [],
  selectedCatalogItems: [],
  catalogSelectedCategoriesItems: {},
  subscriptionType: {
    casualDiningManagement: true,
    fastFoodOthersManagement: false,
    hospitalityAndHotelsManagement: false,
    multiSelectServices: false,
  },
  curbSidePickupDetails: {
    lat: "",
    lng: "",
    placeId: "",
    address: "",
  },
  curbSidePickupDetailsArr: [],
  fastFoodPickupDetailsArr: [],
  multiServicePickupDetailsArr: [],
  set_product_classification: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADMIN_ONBOARD_SET_CURRENT_USER: {
      return {
        ...state,
        user: action.payload,
        isAuthenticated: !isEmpty(action.payload),
      };
    }
    case ADMIN_ONBOARD_SET_CURRENT_USER_DECODED_TOKEN: {
      return {
        ...state,
        decodedToken: action.payload,
      };
    }

    case ADMIN_ONBOARD_UPDATE_SUBSCRIPTION_TYPE:
      return {
        ...state,
        subscriptionType: action.payload,
      };
    case ADMIN_ONBOARD_SET_CURBSIDE_LOCATION:
      return {
        ...state,
        curbSidePickupDetails: action.payload,
      };
    case ADMIN_ONBOARD_SET_CURBSIDE_LOCATION_ARR:
      return {
        ...state,
        curbSidePickupDetailsArr: action.payload,
      };
    case ADMIN_ONBOARD_SET_FASTFOOD_CURBSIDE_LOCATION_ARR:
      return {
        ...state,
        fastFoodPickupDetailsArr: action.payload,
      };
    case ADMIN_ONBOARD_SET_MULTISERVICE_CURBSIDE_LOCATION_ARR:
      return {
        ...state,
        multiServicePickupDetailsArr: action.payload,
      };

    case ADMIN_ONBOARD_SET_PLACE_ID:
      return {
        ...state,
        place_id: action.payload,
      };
    case ADMIN_ONBOARD_SET_PLACE_ID_MARKER:
      return {
        ...state,
        placeIdMarker: action.payload,
      };
    case ADMIN_ONBOARD_GET_MARKER_POSITION:
      return {
        ...state,
        markerPosition: action.payload,
      };
    case ADMIN_ONBOARD_GET_OPEN_RESTAURANT_STATUS:
      return {
        ...state,
        restaurant_Open_Status: action.payload,
      };
    case ADMIN_ONBOARD_SET_RESTAURANT_DETAILS:
      return {
        ...state,
        restaurantDetails: action.payload,
      };
    case ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS:
      return {
        ...state,
        onboard_subscription_details: action.payload,
      };
    case ADMIN_ONBOARD_GET_VENDOR_MENU_CATEGORY:
      return {
        ...state,
        menuCategory: action.payload,
      };
    case ADMIN_ONBOARD_GET_VENDOR_MENU_CATEGORY_ITEMS:
      return {
        ...state,
        menuCategoryItems: action.payload,
      };
    case ADMIN_ONBOARD_SET_PRODUCT_CLASSIFCATION:
      return {
        ...state,
        set_product_classification: action.payload,
      };
    case ADMIN_ONBOARD_SET_ACTIVE_ITEM_ID_MENU_SETUP:
      return {
        ...state,
        activeItemId: action.payload,
      };
    case ADMIN_ONBOARD_GET_VENDOR_ADDED_TEMPLATES:
      return {
        ...state,
        vendor_templates: action.payload,
      };
    case ADMIN_ONBOARD_SET_ACTIVE_CATEGORY_DATA_MENU_SETUP:
      return {
        ...state,
        activeCategoryData: action.payload,
      };
    case ADMIN_ONBOARD_GET_VENDOR_ALL_MENU_ITEMS:
      return {
        ...state,
        all_menu_items: action.payload,
      };
    case ADMIN_ONBOARD_GET_LOCAL_CATALOG_DATA:
      return {
        ...state,
        all_local_catalog: action.payload,
      };
    case ADMIN_ONBOARD_GET_LOCAL_ITEMS_DATA:
      return {
        ...state,
        all_local_catalog_items: action.payload,
      };
    case ADMIN_ONBOARD_ACTIVE_CATALOG_NAME:
      return {
        ...state,
        activeCatalogName: action.payload,
      };
    case ADMIN_ONBOARD_ACTIVE_CATALOG_ID:
      return {
        ...state,
        selectedCatalogId: action.payload,
      };
    case ADMIN_ONBOARD_SELECTED_ITEMS_ID:
      return {
        ...state,
        selectedItemsId: action.payload,
      };
    case ADMIN_ONBOARD_SELECTED_CATALOG_ITEMS:
      return {
        ...state,
        selectedCatalogItems: action.payload,
      };
    case ADMIN_ONBOARD_CATALOG_SELECTED_CATEGORIES_ITEMS:
      return {
        ...state,
        catalogSelectedCategoriesItems: action.payload,
      };

    case LOG_OUT: {
      return {
        ...state,
        place_id: {},
        placeIdMarker: {},
        markerPosition: [],
        restaurantDetails: {},
        onboard_subscription_details: {},
        menuCategory: [],
        activeCategoryData: [],
        menuCategoryItems: [],
        activeItemId: "",
        vendor_templates: [],
        subscriptionType: {},
        all_menu_items: [],
      };
    }
    default:
      return state;
  }
}
